import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	root: {
		marginTop: theme.spacing.unit * 6,
		textAlign: 'center'
	}
})

const StompunktLoading = ({ classes }) => (
	<div className={classes.root}>
		<CircularProgress color="secondary" />
	</div>
)

export default withStyles(styles)(StompunktLoading)



// WEBPACK FOOTER //
// ./src/components/Stompunkt/StompunktLoading.js